// extracted by mini-css-extract-plugin
module.exports = {"tiraAudios":"tiraaudios_tiraAudios__8HUEr"};